/**
 * Read claims out of a JWT access token.
 *
 * The role is taken from the token rather than from the login response body:
 * the token is signed by the server, so a client that edits the JSON response
 * (e.g. through an intercepting proxy) cannot promote itself to an admin view.
 * This is presentation only — the backend re-reads the role from the database
 * for every authorization decision.
 */
export const decodeJwt = (token) => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

/**
 * Resolve the role to display for a session.
 *
 * - token carries a role claim  -> use it (signed, cannot be tampered with)
 * - token is valid but has no role claim -> fall back to the response body,
 *   so an older backend that does not set the claim keeps working
 * - token missing or unreadable -> assume the least privilege
 */
export const resolveRole = (token, bodyRole) => {
  const claims = decodeJwt(token);
  if (!claims) return "USER";
  const claimed = claims.role;
  if (typeof claimed === "string" && claimed) return claimed.toUpperCase();
  return bodyRole || "USER";
};
